import { requestBuilder } from '../../http/RequestBuilder';

export enum MoneyMapResetState {
    RESET_INCOME_SPLIT = 'reset_income_split',
    RESET_OPENING_APEX_ACCOUNTS = 'reset_opening_apex_accounts',
    RESET_OPENING_ACCOUNTS = 'reset_opening_accounts',
    RESET_MONEY_MAP_REVIEW = 'reset_money_map_review',
    RESET_MONEY_MAP_STATUS_TO_DRAFT = 'reset_money_map_status_to_draft',
}

export interface MoneyMapResetDto {
    moneyMapId: string;
    resetState: MoneyMapResetState;
}

// Only works outside of production
export const useResetMoneyMap = requestBuilder.mutation<
    { success: boolean },
    MoneyMapResetDto
>({
    endpoint: () => `/api/money-map/reset`,
    method: 'POST',
});
